module.exports = __webpack_public_path__ + "img/highlight_2.02ff4388.png";